import { handleActions } from 'redux-actions';

import types from './types';
import { mergeDeep } from '../../utils/helpers/ramdaStateHelpers';

const reducer = handleActions({
  [types.SET_ROLES]: mergeDeep(({ payload: { data: { entities, result }, count, hasMore } }) => ({
    entities: { roles: entities.roles },
    result: { roles: result },
    countRoles: count,
    hasMoreRoles: hasMore,
  })),
  [types.SET_MODULES]: mergeDeep(({ payload: { data } }) => ({
    modules: data,
  })),
  [types.SET_ROLE]: mergeDeep(({ payload: { role, roleId } }) => ({
    roles: { [roleId]: role },
  })),
}, {
  isValidUser: false,
});

export default reducer;
